import { combineReducers } from 'redux';
import cartSlice from './Addtochart'
import wishlistSlice from './wishlistSlice';
const rootReducer = combineReducers({
   chart: cartSlice,
   wishlist: wishlistSlice,
});

export default rootReducer;